<template>
  <CompanyEdit v-if="companyId" :company-id="companyId" :super-admin="false"/>
</template>

<script>
import CompanyEdit from "@/components/CompanyEdit";

export default {
  name: "CompanySettings",
  components: {CompanyEdit},
  data: () => ({
    companyId: null
  }),
  mounted() {
    this.$httpUserApi.get((user) => {
      this.companyId = user.companyId;
    });
  },
}
</script>
